export class FlightRepriceFormModel {
  /**
   *
   * @param requestType string，请求类型，Reprice，StoreFare
   * @param airItineraryRPH
   * @param recordLocator string
   * @param idType string,id类型，如RECORD_LOCATOR
   * @param idContext string，id所属系统，如SQ
   * @param passengers Array，TripAirItemPassengerVO对象数组
   * @param flightSegments Array，FlightSegmentVO对象数组
   * @param paymentDetails TripAirItemPaymentDetailVO对象
   * @param servicesSelected Array，TripAirItemAncillaryFareVO对象数组
   */
  constructor(
    requestType,
    airItineraryRPH,
    recordLocator,
    idType,
    idContext,
    passengers,
    flightSegments,
    paymentDetails,
    servicesSelected
  ) {
    this.requestType = requestType;
    this.recordLocator = recordLocator;
    this.airItineraryRPH = airItineraryRPH;
    this.idType = idType;
    this.idContext = idContext;
    this.passengers = passengers;
    this.flightSegments = flightSegments;
    this.paymentDetails = paymentDetails;
    this.servicesSelected = servicesSelected;
  }

  addServiceSelected(serviceSelected) {
    if (!this.servicesSelected) this.servicesSelected = [];

    const ancillaryId = serviceSelected.ancillaryId;
    const travelerRPH = serviceSelected.travelerRPH;
    const flightSegmentRPH = serviceSelected.flightSegmentRPH;
    const quantity = serviceSelected.quantity;
    if (!quantity) return;

    if (this.servicesSelected.length === 0) {
      this.servicesSelected.push(serviceSelected);
    } else {
      let contain = false;
      this.servicesSelected.forEach((service) => {
        if (
          service.ancillaryId === ancillaryId &&
          service.travelerRPH === travelerRPH &&
          service.flightSegmentRPH === flightSegmentRPH
        ) {
          service.quantity += quantity;
          contain = true;
        }
      });

      if (!contain) {
        this.servicesSelected.push(serviceSelected);
      }
    }
  }

  updateServiceSelected(serviceSelected) {
    if (!this.servicesSelected) this.servicesSelected = [];
    const serviceType = serviceSelected.type;
    const ancillaryId = serviceSelected.ancillaryId;
    const travelerRPH = serviceSelected.travelerRPH;
    const flightSegmentRPH = serviceSelected.flightSegmentRPH;
    const quantity = serviceSelected.quantity;
    if (serviceType !== "SEAT" && !quantity) return;

    if (this.servicesSelected.length === 0) {
      this.servicesSelected.push(serviceSelected);
    } else if (serviceType === "SEAT") {
      let contain = false;

      const find = this.servicesSelected.find((service) => {
        const seatColumnNumberCompare = serviceSelected.seatColumnNumber;
        const seatRowNumberCompare = serviceSelected.seatRowNumber;
        const seatColumnNumber = service.seatColumnNumber;
        const seatRowNumber = service.seatRowNumber;

        if (
          service.travelerRPH !== travelerRPH &&
          service.flightSegmentRPH === flightSegmentRPH &&
          service.type === serviceType &&
          seatRowNumber === seatRowNumberCompare &&
          seatColumnNumber === seatColumnNumberCompare
        ) {
          return true;
        }

        return false;
      });

      if (find) return;

      for (const service of this.servicesSelected) {
        if (
          service.travelerRPH === travelerRPH &&
          service.flightSegmentRPH === flightSegmentRPH &&
          service.type === serviceType
        ) {
          service.status = serviceSelected.status;
          service.type = serviceSelected.type;
          service.code = serviceSelected.code;
          service.name = serviceSelected.name;
          service.currencyCode = serviceSelected.currencyCode;
          service.amount = serviceSelected.amount;
          service.ancillaryId = serviceSelected.ancillaryId;
          service.flightSegmentRPH = serviceSelected.flightSegmentRPH;
          service.travelerRPH = serviceSelected.travelerRPH;
          service.quantity = serviceSelected.quantity;
          service.seatColumnNumber = serviceSelected.seatColumnNumber;
          service.seatRowNumber = serviceSelected.seatRowNumber;
          service.bookingInstruction = serviceSelected.bookingInstruction;
          service.imageUrl = serviceSelected.imageUrl;
          service.descriptions = serviceSelected.descriptions;
          service.groups = serviceSelected.groups;

          contain = true;
        }
      }

      if (!contain) {
        this.servicesSelected.push(serviceSelected);
      }
    } else {
      let contain = false;
      this.servicesSelected.forEach((service) => {
        if (
          service.ancillaryId === ancillaryId &&
          service.travelerRPH === travelerRPH &&
          service.flightSegmentRPH === flightSegmentRPH
        ) {
          service.quantity = quantity;
          contain = true;
        }
      });

      if (!contain) {
        this.servicesSelected.push(serviceSelected);
      }
    }
  }

  /**
   *
   * @param flightSegmentRPH
   * @param travelerRPH
   * @param ancillaryId
   * @param quantity number，减去附加服务的数量
   */
  removeService(flightSegmentRPH, travelerRPH, ancillaryId, quantity) {
    if (!this.servicesSelected || this.servicesSelected.length === 0) return;

    for (let i = 0; i < this.servicesSelected.length; i++) {
      const serviceSelected = this.servicesSelected[i];
      if (
        serviceSelected.ancillaryId === ancillaryId &&
        serviceSelected.travelerRPH === travelerRPH &&
        serviceSelected.flightSegmentRPH === flightSegmentRPH
      ) {
        if (quantity) {
          serviceSelected.quantity -= quantity;
          if (serviceSelected.quantity <= 0) {
            this.servicesSelected.splice(i, 1);
          }

          return;
        }

        this.servicesSelected.splice(i, 1);
      }
    }
  }

  calculateServicesTotalPrice() {
    if (!this.servicesSelected || this.servicesSelected.length === 0)
      return null;

    let totalAmount = 0;
    let currency = null;

    for (const serviceSelected of this.servicesSelected) {
      const quantity = serviceSelected.quantity;
      const currencyCode = serviceSelected.currencyCode;
      const amount = serviceSelected.amount;

      if (!currency && currencyCode) currency = currencyCode;

      totalAmount += amount * quantity;
    }

    return {
      amount: totalAmount,
      currencyCode: currency,
    };
  }
}
